import React from 'react'

import type { TableData } from '@fourthwall/components'
import { List, Table, useMediaQueryContext } from '@fourthwall/components'

import { useShopTime } from '../../../../../../../../../Timezone/providers/ShopTimeProvider'
import type { Transaction } from '../../Transactions.types'
import { TransactionsListItem } from '../TransactionsListItem/TransactionsListItem'
import { getHeaders } from './headers'

type TransactionsDataProps = {
  data: Transaction[]
  isLoading?: boolean
}

export const TransactionsData = ({ data, isLoading }: TransactionsDataProps) => {
  const media = useMediaQueryContext()
  const { timezoneAbbreviation } = useShopTime()

  const emptyMessage =
    'You have no earnings history yet. As you earn money through contributions, your earnings will show up here.'

  const getHighlightedRow = ({ type }: Transaction | TableData) => type === 'MANUAL_PAYOUT'

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        emptyComponent={emptyMessage}
        renderItem={(transactionItem: Transaction) => (
          <TransactionsListItem transactionItem={transactionItem} />
        )}
        getItemHighlighted={getHighlightedRow}
      />
    )
  }

  return (
    <Table
      headers={getHeaders(timezoneAbbreviation)}
      data={data}
      emptyMessage={emptyMessage}
      isLoading={isLoading}
      getRowHighlighted={getHighlightedRow}
    />
  )
}
